import $ from 'jquery'

(function () {
  var originalFocusMethod = $.fn.focus

  $.fn.focus = function () {
    var that = this
    originalFocusMethod.apply(that, arguments)
  }

  $.fn.positionAt = function (parent) {
    if (this.length === 0) {
      return
    }

    if (parent == null) {
      return this.position()
    } else {
      parent = parent.length ? parent[0] : parent
      var pos = this.position()
      var $parents = this.parents()
      for (var i = 0; i < $parents.length; i++) {
        var p = $parents[i]

        if (p === parent) {
          break
        }

        pos.top += p.offsetTop
        pos.left += p.offsetLeft
      }

      return pos
    }
  }

  $.fn.scrollTo = function (element) {
    if (element == null || element.length === 0) {
      return
    }

    element = $(element)

    var viewPort = this[0]

    var originParentPosition = $(viewPort).css('position')
    $(viewPort).css('position', 'relative')

    var border = parseFloat($(viewPort).css('border-top-width')) + parseFloat($(viewPort).css('border-bottom-width'))

    var scrollTop = $(viewPort).scrollTop()
    var screenHeight = viewPort.clientHeight + border - 7 // why 7?!

    var viewScreen = {
      top: scrollTop,
      bottom: scrollTop + screenHeight,
      height: screenHeight,

      inBounds(point) {
        if (point >= this.top && point <= this.bottom) {
          return true
        }

        return false
      },
      getTargetPoint(el, point) {
        let target = 0

        if (el.top < this.top) {
          let diff = this.top - el.top

          target = this.top - diff
        } else if (el.bottom > this.bottom) {
          let diff = el.bottom - this.bottom
          target = this.top + diff
        } else {
          target = point
        }

        if (target < 0) {
          target = 0
        }

        return target
      },
      fitInPort(el) {
        return this.height >= el.height
      },
      inUpHalfBounds(point) {
        if (point >= this.top && point <= this.top + (this.height / 2)) {
          return true
        }

        return false
      }
    }

    let elHeight = parseFloat(element.height())
    let elTop = element.positionAt(viewPort).top
    let additionTop = elTop !== element.position().top ? 0 : viewScreen.top
    let elementScreen = {
      top: additionTop + elTop,
      height: elHeight,
      bottom: additionTop + elTop + elHeight
    }

    var target = null
    let fit = viewScreen.fitInPort(elementScreen)

    if (fit) {
      if (!viewScreen.inBounds(elementScreen.top)) {
        target = viewScreen.getTargetPoint(elementScreen, elementScreen.top)
      } else if (!viewScreen.inBounds(elementScreen.bottom)) {
        target = viewScreen.getTargetPoint(elementScreen, elementScreen.bottom)
      }
    } else {
      if (!viewScreen.inUpHalfBounds(elementScreen.top)) {
        target = viewScreen.top + (viewScreen.height / 4)
      }
    }

    if (target != null) {
      $(viewPort).scrollTop(target)
    }

    $(viewPort).css('position', originParentPosition)
  }

  $.fn.scroller = function () {
    var jel = this
    if (jel.length > 0) {
      const hasScroll = function (element) {
        return element.scrollHeight > element.offsetHeight
      }

      var el = jel[0]
      if (hasScroll(el)) {
        return $(el)
      } else {
        var parents = $(el).parents()
        for (var i = 0; i < parents.length; i++) {
          var p = parents[i]
          var $p = $(p)
          if (hasScroll(p) && !$p.hasClass('app-body')) {
            return $p
          }
        }
        return jel
      }
    } else {
      return jel
    }
  }

  $.fn.heightToBottom = function () {
    this.each(function (i, el) {
      var child = $(el)

      if (child.hasClass('height-to-bottom-done')) {
        return
      }

      if (child.parents('.height-to-bottom:not(.height-to-bottom-done)').length > 0) {
        child.parents('.height-to-bottom:not(.height-to-bottom-done)').heightToBottom()
      }

      var parent = child.parent()

      var originParentPosition = parent.css('position')
      parent.css('position', 'relative')

      var parentHeight = parent.height()
      var ppt = parseFloat(parent.css('padding-top'))
      var ppb = parseFloat(parent.css('padding-bottom'))
      var pbt = parseFloat(parent.css('border-top-width'))
      var pbb = parseFloat(parent.css('border-bottom-width'))

      var mergedHeight = parentHeight + ppt + ppb + pbt + pbb
      if (mergedHeight === parentHeight) {
        mergedHeight -= (ppt + ppb + pbt + pbb)
      }

      parentHeight = mergedHeight

      var top = child.position().top
      var height = parentHeight - top
      var marginTop = parseFloat(child.css('margin-top'))
      var marginBottom = parseFloat(child.css('margin-bottom'))

      height = height - (ppb + pbb)
      height = height - (marginTop + marginBottom)

      var minHeight = child.css('min-height')
      if (minHeight && !isNaN(minHeight)) {
        minHeight = parseFloat(minHeight)
      } else {
        minHeight = 0
      }

      if (minHeight < height) {
        child.css('height', height)
      }

      child.addClass('height-to-bottom-done')
      parent.css('position', originParentPosition)
    })
  }

  var origScrollLeft = $.fn.scrollLeft
  $.fn.scrollLeft = function (i) {
    if ($.support.rtlScrollType === 'default') {
      return origScrollLeft.apply(this, arguments)
    } else {
      var leftEdge = this[0].scrollWidth - this[0].clientWidth

      if (i == null) {
        let value = origScrollLeft.apply(this, arguments)

        switch ($.support.rtlScrollType) {
          case 'negative':
            return value + leftEdge
          case 'reverse':
            return leftEdge - value
          default:
            throw new Error('not supported scroll mode')
        }
      } else {
        switch ($.support.rtlScrollType) {
          case 'negative':
            leftEdge = -leftEdge
            return origScrollLeft.call(this, leftEdge + i)
          case 'reverse':
            return origScrollLeft.call(this, leftEdge - i)
          default:
            throw new Error('not supported scroll mode')
        }
      }
    }
  }

  $.fn.scrollRight = function (val) {
    if (val === undefined) {
      return this[0].scrollWidth - ($(this[0]).scrollLeft() + this[0].clientWidth)
    }

    return this.scrollLeft(this[0].scrollWidth - this[0].clientWidth - val)
  }

  $.fn.preBind = function (type, data, fn) {
    this.each(function () {
      var $this = $(this)

      $this.bind(type, data, fn)

      var allEvents = $._data($this.get(0), 'events')
      var currentBindings = allEvents[type]
      if ($.isArray(currentBindings)) {
        currentBindings.unshift(currentBindings.pop())
      }
    })
    return this
  }
})()
